<mat-card class="alumno-chip-card">
  <mat-card-header>
    <!-- Avatar -->
    <div mat-card-avatar *ngIf="image" class="alumno-avatar">
      <img width="50px" height="50px" mat-card-image [src]="persona.imageUrl || 'https://mi.glm.edu.co/Images/shadow-user.jpg'" 
           alt="Foto de {{persona.apellidosNombres}}">
    </div>
    
    <!-- Título y subtítulo -->
    <mat-card-title class="alumno-name">{{persona.apellidosNombres}}</mat-card-title>
    
    <mat-card-subtitle *ngIf="view > 0">
      <mat-chip-set>
        <mat-chip *ngFor="let chip of chips" 
                 [matTooltip]="chip.tooltip"
                 [style.backgroundColor]="chip.styles?.backgroundColor"
                 [style.color]="chip.styles?.color">
          {{chip.label}}
        </mat-chip>
      </mat-chip-set>
    </mat-card-subtitle>
    
    <!-- Menú de acciones -->
    <div class="alumno-actions" *ngIf="acciones.length + accionesGlobales.length > 0">
      <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="!menuActivo"
              aria-label="Más acciones">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button *ngFor="let accion of acciones" mat-menu-item
                (click)="ejecutarAccion(accion)">
          {{accion.label}}
        </button>
        <mat-divider *ngIf="acciones.length > 0 && accionesGlobales.length > 0"></mat-divider>
        <button *ngFor="let accion of accionesGlobales" mat-menu-item
                (click)="ejecutarAccion(accion)">
          {{accion.label}}
        </button>
      </mat-menu>
    </div>
  </mat-card-header>

  <!-- Email (para view > 1) -->
  <mat-card-content *ngIf="view > 1 && persona.eMail" class="alumno-email">
    <mat-icon>email</mat-icon>
    <span>{{persona.eMail}}</span>
  </mat-card-content>
</mat-card>